import { NOLA_PHONE, locationSchema } from "../structured-data-core";

export function getNewOrleansStructuredData() {
  const url = "https://restorehair.com/locations/louisiana/new-orleans/";
  const description =
    "Find out about your hair transplant options in New Orleans with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("New Orleans", "1615 Poydras St, Suite 900", "New Orleans", "LA", NOLA_PHONE, url, description),
  ];
}
